<template>
  <div class="container">
    <div class="back" @click="back">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="">
      <span>{{ $t('personal.back') }}</span>
    </div>
    <div class="title">
      {{ $t('personal.title') }}
    </div>
    <a-tabs :activeKey="activeKey" tab-position="left" @change="change">
      <a-tab-pane key="1" :tab="$t('personal.tabs.info')">
        <div class="form">
          <!--用户信息预览 -->
          <div v-if="!visible">
            <div class="list">
              <div class="form-item">
                <div class="label">{{ $t('personal.form.avatar') }}</div>
                <img
                  class="avatar"
                  :src="user.avatar ? user.avatar : require('@/assets/icons/icon_m.png')"
                  alt=""
                  srcset=""
                />
              </div>
            </div>
            <!-- 校内师生信息 -->
            <div class="form-content" v-if="isCampus">
              <div class="form-item">
                <div class="label">{{ $t('personal.form.name') }}</div>
                <div class="input">{{ displayData(user.name) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.school') }}</div>
                <div class="input">{{ displayData(user.schoolName) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.gender') }}</div>
                <div class="input">{{ user.gender === '1' ? $t('personal.form.modal.gender.male') : $t('personal.form.modal.gender.female') }}</div>
              </div>
              <div class="form-item" v-if="role === 'teacher'">
                <div class="label">{{ $t('personal.form.rank') }}</div>
                <div class="input">{{ displayData(user.rankName) }}</div>
              </div>
              <div class="form-item" v-if="role === 'teacher'">
                <div class="label">{{ $t('personal.form.age') }}</div>
                <div class="input">{{ displayData(user.age) }}</div>
              </div>
              <div class="form-item" v-if="role === 'teacher'">
                <div class="label">{{ $t('personal.form.education') }}</div>
                <div class="input">{{ displayData(user.educationName) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.account') }}</div>
                <div class="input">{{ displayData(user.username) }}</div>
              </div>
              <div class="form-item" v-if="role === 'student'">
                <div class="label">{{ $t('personal.form.class') }}</div>
                <div class="input">{{ displayData(user.className) }}</div>
              </div>
              <div class="form-item" v-if="role === 'teacher'">
                <div class="label">{{ $t('personal.form.degree') }}</div>
                <div class="input">{{ displayData(user.degreeStr) }}</div>
              </div>
              <div class="form-item" v-if="role === 'teacher'">
                <div class="label">{{ $t('personal.form.birthDate') }}</div>
                <div class="input">{{ user.birthDate !== '' ? user.birthDate : $t('personal.form.modal.location.none') }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.email') }}</div>
                <div class="input">{{ displayData(user.email) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.phone') }}</div>
                <div class="input">{{ displayData(user.phone) }}</div>
              </div>
              <div class="form-item" v-if="role === 'teacher'">
                <div class="label">{{ $t('personal.form.employeeNumber') }}</div>
                <div class="input">{{ displayData(user.employeeNumber) }}</div>
              </div>
              <div class="form-item" v-if="role === 'student'">
                <div class="label">{{ $t('personal.form.enrollmentYear') }}</div>
                <div class="input">{{ displayData(user.enrollmentYear) }}</div>
              </div>
              <div class="form-item" v-if="role === 'teacher'">
                <div class="label">{{ $t('personal.form.position') }}</div>
                <div class="input">{{ displayData(user.position) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.department') }}</div>
                <div class="input">{{ displayData(user.department) }}</div>
              </div>
              <div class="form-item" v-if="role === 'teacher'">
                <div class="label">{{ $t('personal.form.teacherType') }}</div>
                <div class="input">{{ displayData(user.teacherTypeStr) }}</div>
              </div>
              <div class="form-item" v-if="role === 'student'">
                <div class="label">{{ $t('personal.form.studentNumber') }}</div>
                <div class="input">{{ displayData(user.studentNumber) }}</div>
              </div>
            </div>
            <!-- 校外师生信息 -->
            <div class="form-content" v-else>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.schoolName') }}</div>
                <div class="input">{{ displayData(user.schoolName) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.schoolLocation') }}</div>
                <div class="input">{{ user.schoolLocation === '1' ? $t('personal.form.modal.location.domestic') : user.schoolLocation === '2' ? $t('personal.form.modal.location.foreign') : $t('personal.form.modal.location.none') }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.schoolCountry') }}</div>
                <div class="input">{{ displayData(user.schoolCountry) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.employeeOrStudentNumber') }}</div>
                <div class="input">{{ displayData(user.employeeNumber) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.name') }}</div>
                <div class="input">{{ displayData(user.name) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.loginAccount') }}</div>
                <div class="input">{{ displayData(user.username) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.gender') }}</div>
                <div class="input">{{ displayData(user.gender === '1' ? $t('personal.form.modal.gender.male') : $t('personal.form.modal.gender.female')) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.phone') }}</div>
                <div class="input">{{ displayData(user.phone) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.belongDepartment') }}</div>
                <div class="input">{{ displayData(user.department) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.belongMajor') }}</div>
                <div class="input">{{ displayData(user.profession) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.enrollmentYear') }}</div>
                <div class="input">{{ displayData(user.enrollmentYear) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.class') }}</div>
                <div class="input">{{ displayData(user.class) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.idCardNumber') }}</div>
                <div class="input">{{ displayData(user.idCardNumber) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.email') }}</div>
                <div class="input">{{ displayData(user.email) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.address') }}</div>
                <div class="input">{{ displayData(user.address) }}</div>
              </div>
              <div class="form-item">
                <div class="label">{{ $t('personal.form.organization') }}</div>
                <div class="input">{{ displayData(user.organization) }}</div>
              </div>
            </div>
          </div>
          <!--用户信息编辑 -->
          <div v-else>
            <!-- 校内师生 -->
            <a-form :form="form" :layout="inline" v-if="isCampus">
              <div class="list">
                <a-form-item class="avatar-item" :label="$t('personal.form.avatar')" :colon="false">
                  <upload class="avatar-upload" @uploadData="uploadData" v-decorator="['avatar']" />
                  <img
                    class="avatar"
                    :src="
                      form.getFieldValue('avatar') ? form.getFieldValue('avatar') : require('@/assets/icons/icon_m.png')
                    "
                    alt=""
                    srcset=""
                  />
                </a-form-item>
              </div>
              <div class="form-content">
                <a-form-item :label="$t('personal.form.name')" :colon="false">
                  <a-input
                    maxLength="8"
                    v-decorator="['name', { rules: [{ required: true, message: $t('personal.form.modal.validate.name') }] }]"
                    :placeholder="$t('personal.form.modal.validate.name')"
                  />
                </a-form-item>
                <a-form-item :label="$t('personal.form.school')" :colon="false">
                  <a-input disabled v-decorator="['schoolName', { rules: [{ required: true }] }]" />
                </a-form-item>
                <a-form-item :label="$t('personal.form.gender')" :colon="false">
                  <a-select
                    v-decorator="['gender', { rules: [{ required: true, message: $t('personal.form.modal.validate.gender') }] }]"
                    :placeholder="$t('personal.form.modal.validate.gender')"
                  >
                    <a-select-option value="1">{{ $t('personal.form.modal.gender.male') }}</a-select-option>
                    <a-select-option value="2">{{ $t('personal.form.modal.gender.female') }}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item class="full" :label="$t('personal.form.rank')" :colon="false" v-if="role === 'teacher'">
                  <a-select
                    allowClear
                    v-decorator="['rank_id', { rules: [{ required: true, message: $t('personal.form.modal.validate.rank') }] }]"
                    :placeholder="$t('personal.form.modal.validate.rank')"
                  >
                    <a-select-option v-for="(item, key) in rankTypeList" :key="key" :value="item.id">{{
                      item.name
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item class="full" :label="$t('personal.form.age')" :colon="false" v-if="role === 'teacher'">
                  <a-select
                    allowClear
                    v-decorator="['age', { rules: [{ required: true, message: $t('personal.form.modal.validate.age') }] }]"
                    :placeholder="$t('personal.form.modal.validate.age')"
                  >
                    <a-select-option v-for="(item, key) in ageList" :key="key" :value="item.id">{{
                      item.name
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :label="$t('personal.form.education')" :colon="false" v-if="role === 'teacher'">
                  <a-select
                    allowClear
                    v-decorator="['education_id', { rules: [{ required: true, message: $t('personal.form.modal.validate.education') }] }]"
                    :placeholder="$t('personal.form.modal.validate.education')"
                  >
                    <a-select-option v-for="(item, key) in eduTypeList" :key="key" :value="item.id">{{                      item.name
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :label="$t('personal.form.account')" :colon="false">
                  <a-input
                    disabled
                    v-decorator="['username', { rules: [{ required: true }] }]"
                    :placeholder="$t('personal.form.modal.placeholder.account')"
                  />
                </a-form-item>
                <a-form-item :label="$t('personal.form.class')" :colon="false" v-if="role === 'student'">
                  <a-input disabled v-decorator="['className', { rules: [] }]" :placeholder="$t('personal.form.modal.placeholder.class')" />
                </a-form-item>
                <a-form-item :label="$t('personal.form.degree')" :colon="false" v-if="role === 'teacher'">
                  <a-select
                    allowClear
                    v-decorator="['degreeId', { rules: [{ required: true, message: $t('personal.form.modal.validate.degree') }] }]"
                    :placeholder="$t('personal.form.modal.placeholder.degree')"
                  >
                    <a-select-option v-for="(item, key) in qualificationList" :key="key" :value="item.value">{{
                      item.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :label="$t('personal.form.birthDate')" :colon="false" v-if="role === 'teacher'">
                  <a-date-picker
                    v-decorator="['birthDate', { rules: [] }]"
                    :placeholder="$t('personal.form.modal.placeholder.birthDate')"
                    format="YYYY-MM-DD"
                    valueFormat="YYYY-MM-DD"
                    style="width: 100%;"
                  />
                </a-form-item>
                <a-form-item :label="$t('personal.form.email')" :colon="false">
                  <a-input
                    v-decorator="[
                      'email',
                      {
                        rules: [
                          {
                            pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
                            message: $t('personal.form.modal.validate.emailFormat')
                          }
                        ]
                      }
                    ]"
                    :placeholder="$t('personal.form.modal.placeholder.email')"
                  />
                </a-form-item>
                <a-form-item :label="$t('personal.form.phone')" :colon="false">
                  <a-input
                    v-decorator="[
                      'phone',
                      {
                        rules: [
                          {
                            pattern: /^1[3456789]\d{9}$/,
                            message: $t('personal.form.modal.validate.phoneFormat')
                          }
                        ]
                      }
                    ]"
                    :placeholder="$t('personal.form.modal.placeholder.phone')"
                  />
                </a-form-item>
                <a-form-item :label="$t('personal.form.employeeNumber')" :colon="false" v-if="role === 'teacher'">
                  <a-input v-decorator="['employeeNumber', { rules: [] }]" :placeholder="$t('personal.form.modal.placeholder.employeeNumber')" />
                </a-form-item>
                <a-form-item :label="$t('personal.form.position')" :colon="false" v-if="role === 'teacher'">
                  <a-input v-decorator="['position', { rules: [] }]" :placeholder="$t('personal.form.modal.placeholder.position')" />
                </a-form-item>
                <a-form-item :label="$t('personal.form.enrollmentYear')" :colon="false" v-if="role === 'student'">
                  <a-input disabled v-decorator="['enrollmentYear', { rules: [] }]" placeholder="" />
                </a-form-item>
                <a-form-item :label="$t('personal.form.department')" :colon="false">
                  <a-input v-decorator="['department', { rules: [] }]" :placeholder="$t('personal.form.modal.placeholder.department')" />
                </a-form-item>
                <a-form-item :label="$t('personal.form.studentNumber')" :colon="false" v-if="role === 'student'">
                  <a-input v-decorator="['studentNumber', { rules: [{ required: true }] }]" :placeholder="$t('personal.form.modal.placeholder.studentNumber')" />
                </a-form-item>
                <a-form-item :label="$t('personal.form.teacherType')" :colon="false" v-if="role === 'teacher'">
                  <a-select v-decorator="['teacherType', { rules: [] }]" :placeholder="$t('personal.form.modal.placeholder.teacherType')">
                    <a-select-option v-for="item in teacherTypeList" :key="item.value" :value="item.value">{{
                      item.label
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </div>
            </a-form>
            <!-- 校外师生 -->
            <a-form :form="externalForm" :layout="inline" v-else>
              <div class="list">
                <a-form-item class="avatar-item" :label="'头像'" :colon="false">
                  <upload class="avatar-upload" @uploadData="uploadData" v-decorator="['avatar']" />
                  <img
                    class="avatar"
                    :src="
                      form.getFieldValue('avatar') ? form.getFieldValue('avatar') : require('@/assets/icons/icon_m.png')
                    "
                    alt=""
                    srcset=""
                  />
                </a-form-item>
              </div>
              <div class="form-content">
                <a-form-item :label="$t('personal.form.schoolName')" :colon="false">
                  <a-input
                    v-decorator="[
                      'schoolName',
                      {
                        rules: [{ required: true, message: $t('personal.form.validation.schoolName') }]
                      }
                    ]"
                    :placeholder="$t('personal.form.placeholder.schoolName')"
                  />
                </a-form-item>
                <a-form-item :label="$t('personal.form.schoolLocation')" :colon="false">
                  <a-select v-decorator="['schoolLocation']" :placeholder="$t('personal.form.placeholder.schoolLocation')">
                    <a-select-option value="1">{{ $t('personal.form.modal.location.domestic') }}</a-select-option>
                    <a-select-option value="2">{{ $t('personal.form.modal.location.foreign') }}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :label="$t('personal.form.schoolCountry')" :colon="false">
                  <a-select v-decorator="['schoolCountry']" :placeholder="$t('personal.form.placeholder.schoolCountry')">
                    <a-select-option v-for="item in countryList" :key="item.value" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :label="$t('personal.form.employeeOrStudentNumber')" :colon="false">
                  <a-input v-decorator="['employeeNumber']" :placeholder="$t('personal.form.placeholder.employeeOrStudentNumber')" />
                </a-form-item>
                <a-form-item :label="$t('personal.form.name')" :colon="false">
                  <a-input
                    v-decorator="[
                      'name',
                      {
                        rules: [{ required: true, message: $t('personal.form.validation.name') }]
                      }
                    ]"
                    :placeholder="$t('personal.form.placeholder.name')"
                  />
                </a-form-item>
                <a-form-item :label="$t('personal.form.loginAccount')" :colon="false">
                  <a-input
                    disabled
                    v-decorator="[
                      'username',
                      {
                        rules: [{ required: true, message: $t('personal.form.validation.loginAccount') }]
                      }
                    ]"
                    :placeholder="$t('personal.form.placeholder.loginAccount')"
                  />
                </a-form-item>
                <a-form-item :label="$t('personal.form.password')" :colon="false">
                  <a-input
                    v-decorator="[
                      'password',
                      {
                        rules: []
                      }
                    ]"
                    :placeholder="$t('personal.form.placeholder.password')"
                    type="password"
                  />
                </a-form-item>
                <a-form-item :label="$t('personal.form.confirmPassword')" :colon="false">
                  <a-input
                    v-decorator="[
                      'confirmPassword',
                      {
                        rules: [{ validator: passwordvalidator }]
                      }
                    ]"
                    :placeholder="$t('personal.form.placeholder.confirmPassword')"
                    type="password"
                  />
                </a-form-item>
                <a-form-item :label="$t('personal.form.gender')" :colon="false">
                  <a-select
                    v-decorator="[
                      'gender',
                      {
                        rules: [{ required: true, message: $t('personal.form.validation.gender') }]
                      }
                    ]"
                    :placeholder="$t('personal.form.placeholder.gender')"
                  >
                    <a-select-option value="1">{{ $t('personal.form.modal.gender.male') }}</a-select-option>
                    <a-select-option value="2">{{ $t('personal.form.modal.gender.female') }}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :label="$t('personal.form.phone')" :colon="false">
                  <a-input
                    v-decorator="[
                      'phone',
                      {
                        rules: [{ pattern: /^1[3456789]\d{9}$/, message: $t('personal.form.validation.phone') }]
                      }
                    ]"
                    :placeholder="$t('personal.form.placeholder.phone')"
                  />
                </a-form-item>
                <a-form-item :label="$t('personal.form.belongDepartment')" :colon="false">
                  <a-input v-decorator="['department']" :placeholder="$t('personal.form.placeholder.belongDepartment')" />
                </a-form-item>
                <a-form-item :label="$t('personal.form.belongMajor')" :colon="false">
                  <a-cascader
                    :options="professionList"
                    :fieldNames="fieldNames"
                    v-decorator="['profession', { rules: [] }]"
                    :placeholder="$t('personal.form.placeholder.belongMajor')"
                  />
                </a-form-item>
                <a-form-item :label="$t('personal.form.enrollmentYear')" :colon="false" v-if="role === 'student'">
                  <a-input disabled v-decorator="['enrollmentYear']" :placeholder="$t('personal.form.placeholder.enrollmentYear')" />
                </a-form-item>
                <a-form-item :label="$t('personal.form.class')" :colon="false" v-if="role === 'student'">
                  <a-input disabled v-decorator="['class']" :placeholder="$t('personal.form.placeholder.class')" />
                </a-form-item>
                <a-form-item :label="$t('personal.form.idCardNumber')" :colon="false">
                  <a-input
                    v-decorator="[
                      'idCardNumber',
                      {
                        rules: [
                          { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: $t('personal.form.validation.idCardNumber') }
                        ]
                      }
                    ]"
                    :placeholder="$t('personal.form.placeholder.idCardNumber')"
                  />
                </a-form-item>
                <a-form-item :label="$t('personal.form.email')" :colon="false">
                  <a-input
                    v-decorator="[
                      'email',
                      {
                        rules: [
                          {
                            pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
                            message: $t('personal.form.validation.email')
                          }
                        ]
                      }
                    ]"
                    :placeholder="$t('personal.form.placeholder.email')"
                  />
                </a-form-item>
                <a-form-item :label="$t('personal.form.address')" :colon="false">
                  <a-input v-decorator="['address']" :placeholder="$t('personal.form.placeholder.address')" />
                </a-form-item>
                <a-form-item :label="$t('personal.form.organization')" :colon="false">
                  <a-input v-decorator="['organization']" :placeholder="$t('personal.form.placeholder.organization')" />
                </a-form-item>
              </div>
            </a-form>
          </div>
        </div>
        <div class="button" v-if="visible">
          <a-button type="primary" @click="ok">{{ $t('personal.form.button.save') }}</a-button>
          <a-button @click="visible = false" style="margin-left: 20px;">{{ $t('personal.form.button.cancel') }}</a-button>
        </div>
        <div class="button" v-else>
          <a-button type="primary" @click="editInfo">{{ $t('personal.form.button.edit') }}</a-button>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('personal.tabs.collections.resource')">
        <Resource />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import { teacherSave, externalUserSave } from '@/api/admin'
import { teacherDetail, studentDetail, externalTeacherDetail } from '@/api/index'
import { getRankType, getEducationType, getAdminOrgList, studentSave } from '@/api/lesson'
import cookie from 'js-cookie'
import md5 from 'md5'
import { mapMutations, mapState } from 'vuex'
import { ACCESS_TOKEN, PERSONAL_ACTIVEKEY } from '@/store/mutation-types'
import upload from '@/components/upload/index.vue'
import Resource from './components/resource'
import Course from './components/course'

export default {
  components: {
    upload,
    Resource,
    Course
  },
  data() {
    return {
      user: {
        name: undefined,
        avatar: undefined,
        username: undefined,
        profession: undefined,
        schoolName: undefined
      },
      role: 'teacher',
      visible: false,
      rankTypeList: [],
      eduTypeList: [],
      ageList: [],
      professionList: [],
      fieldNames: { label: 'name', value: 'id', children: 'child' },
      form: this.$form.createForm(this),
      externalForm: this.$form.createForm(this), // 添加 externalForm
      isStudent: false,
      activeKey: '1',
      qualificationList: [
        { value: 1, label: this.$t('personal.form.qualification.doctor') },
        { value: 2, label: this.$t('personal.form.qualification.master') },
        { value: 3, label: this.$t('personal.form.qualification.bachelor') },
        { value: 4, label: this.$t('personal.form.qualification.associate') }
      ],
      teacherTypeList: [
        { value: 1, label: this.$t('personal.form.teacherTypeOptions.fullTime') },
        { value: 2, label: this.$t('personal.form.teacherTypeOptions.contract') },
        { value: 3, label: this.$t('personal.form.teacherTypeOptions.substitute') },
        { value: 4, label: this.$t('personal.form.teacherTypeOptions.partTime') }
      ],
      isCampus: true,
      countryList: [
        { value: this.$t('personal.form.country.china'), label: this.$t('personal.form.country.china') },
        { value: this.$t('personal.form.country.usa'), label: this.$t('personal.form.country.usa') },
        { value: this.$t('personal.form.country.uk'), label: this.$t('personal.form.country.uk') },
        { value: this.$t('personal.form.country.japan'), label: this.$t('personal.form.country.japan') },
        { value: this.$t('personal.form.country.germany'), label: this.$t('personal.form.country.germany') },
        { value: this.$t('personal.form.country.france'), label: this.$t('personal.form.country.france') },
        { value: this.$t('personal.form.country.italy'), label: this.$t('personal.form.country.italy') },
        { value: this.$t('personal.form.country.canada'), label: this.$t('personal.form.country.canada') },
        { value: this.$t('personal.form.country.australia'), label: this.$t('personal.form.country.australia') },
        { value: this.$t('personal.form.country.russia'), label: this.$t('personal.form.country.russia') },
        { value: this.$t('personal.form.country.korea'), label: this.$t('personal.form.country.korea') },
        { value: this.$t('personal.form.country.singapore'), label: this.$t('personal.form.country.singapore') },
        { value: this.$t('personal.form.country.india'), label: this.$t('personal.form.country.india') },
        { value: this.$t('personal.form.country.brazil'), label: this.$t('personal.form.country.brazil') },
        { value: this.$t('personal.form.country.mexico'), label: this.$t('personal.form.country.mexico') },
        { value: this.$t('personal.form.country.southAfrica'), label: this.$t('personal.form.country.southAfrica') },
        { value: this.$t('personal.form.country.spain'), label: this.$t('personal.form.country.spain') },
        { value: this.$t('personal.form.country.portugal'), label: this.$t('personal.form.country.portugal') },
        { value: this.$t('personal.form.country.netherlands'), label: this.$t('personal.form.country.netherlands') },
        { value: this.$t('personal.form.country.switzerland'), label: this.$t('personal.form.country.switzerland') }
      ]
    }
  },
  computed: {
    ...mapState({
      local_activekey: state => state.app.personal_activekey
    })
  },
  methods: {
    ...mapMutations([PERSONAL_ACTIVEKEY]),
    back() {
      this.$router.back()
    },
    uploadData(el) {
      this.form.setFieldsValue({
        avatar: el[0].url
      })
    },
    editInfo() {
      this.visible = true
      this.$nextTick(() => {
        const targetForm = this.isCampus ? this.form : this.externalForm
        if (this.role === 'teacher') {
          console.log('this.user.teacherType ----->', this.user.teacherType)
          if (this.isCampus) {
            targetForm.setFieldsValue({
              name: this.user.name,
              avatar: this.user.avatar,
              username: this.user.username,
              schoolName: this.user.schoolName,
              rank_id: this.user.rankId,
              education_id: this.user.educationId,
              profession: this.user.professionId
                ? [this.user.collegeId, this.user.departmentId, this.user.professionId]
                : undefined,
              age: this.user.age,
              gender: this.user.gender,
              degreeId: this.user.degreeId ? Number(this.user.degreeId) : undefined,
              country: this.user.country,
              location: this.user.location,
              birthDate: this.user.birthDate,
              email: this.user.email,
              phone: this.user.phone,
              employeeNumber: this.user.employeeNumber,
              position: this.user.position,
              department: this.user.department,
              teacherType: this.user.teacherType ? Number(this.user.teacherType) : undefined
            })
          } else {
            targetForm.setFieldsValue({
              name: this.user.name,
              avatar: this.user.avatar,
              username: this.user.username,
              schoolName: this.user.schoolName,
              schoolLocation: this.user.schoolLocation,
              gender: this.user.gender,
              schoolCountry: this.user.schoolCountry,
              employeeNumber: this.user.employeeNumber,
              email: this.user.email,
              phone: this.user.phone,
              department: this.user.department,
              idCardNumber: this.user.idCardNumber,
              address: this.user.address,
              organization: this.user.organization,
              profession: this.user.professionId
                ? [this.user.collegeId, this.user.departmentId, this.user.professionId]
                : undefined
            })
          }
        } else {
          if (this.isCampus) {
            targetForm.setFieldsValue({
              name: this.user.name,
              avatar: this.user.avatar,
              username: this.user.username,
              schoolName: this.user.schoolName,
              profession: this.user.profession,
              gender: this.user.gender,
              className: this.user.className,
              studentNumber: this.user.studentNumber,
              email: this.user.email,
              phone: this.user.phone,
              enrollmentYear: this.user.enrollmentYear ? (this.user.enrollmentYear === '0' ? '' : this.user.enrollmentYear) : '',
              department: this.user.department
            })
          } else {
            targetForm.setFieldsValue({
              name: this.user.name,
              avatar: this.user.avatar,
              username: this.user.username,
              schoolName: this.user.schoolName,
              schoolLocation: this.user.schoolLocation,
              gender: this.user.gender,
              schoolCountry: this.user.schoolCountry,
              employeeNumber: this.user.employeeNumber,
              email: this.user.email,
              phone: this.user.phone,
              department: this.user.department,
              idCardNumber: this.user.idCardNumber,
              address: this.user.address,
              organization: this.user.organization,
              profession: this.user.professionId
                ? [this.user.collegeId, this.user.departmentId, this.user.professionId]
                : undefined,
              enrollmentYear: this.user.enrollmentYear ? (this.user.enrollmentYear === '0' ? '' : this.user.enrollmentYear) : '',
              class: this.user.class
            })
          }
            console.log('this.user.professionId ----->', this.user.professionId)

        }
      })
    },
    ok() {
      const targetForm = this.isCampus ? this.form : this.externalForm
      targetForm.validateFields(async (err, values) => {
        if (!err) {
          const data = Object.assign(values, {
            id: cookie.getJSON('user_infor').id
          })
          if (values.profession && values.profession.length === 3) {
            data.profession_id = values.profession[2]
            data.department_id = values.profession[1]
            data.college_id = values.profession[0]
          }
          if (data.password) {
            data.password = md5(data.password)
          }
          if (this.role === 'teacher') {
            if (this.isCampus) {
              const res = await teacherSave(data)
              if (res.code !== 200) return
            } else {
              const res = await externalUserSave(data)
              if (res.code !== 200) return
            }
          } else {
            data.status = 1
            if (this.isCampus) {
              const res = await studentSave(data)
              if (res.code !== 200) return
            } else {
              const res = await externalUserSave(data)
              if (res.code !== 200) return
            }
          }
          const user = Object.assign(cookie.getJSON('user_infor'), values)
          cookie.set('user_infor', user, {
            domain: '.' + location.hostname
          })
          this.$message.success(this.$t('personal.form.modal.success'))
          this.visible = false
          this.getUserDetail()
        }
      })
    },
    agefn() {
      for (let i = 20; i < 101; i++) {
        this.ageList.push({
          id: i.toString(),
          name: i + this.$t('personal.form.unit.age')
        })
      }
    },
    // 与后台编辑一致
    async professionMapHttp() {
      const res = await getAdminOrgList()
      if (res.code == 200) {
        this.professionList = res.data.list
        for (const item of this.professionList) {
          if (item.child.length == 0) {
            item.disabled = true
          } else if (item.child.length > 0) {
            for (const items of item.child) {
              if (items.child.length == 0) {
                items.disabled = true
              }
            }
          }
        }
      }
    },
    async getUserDetail() {
      this.agefn()
      this.professionMapHttp()
      if (!this.isCampus) {
        this.getExternalUserDetail()
      } else {
        if (this.role === 'teacher') {
          this.getTeacherDetail()
        } else {
          this.getStudentDetail()
        }
      }
    },
    async getTeacherDetail() {
      const res = await getRankType()
      this.rankTypeList = res.data.list
      const resEdu = await getEducationType()
      this.eduTypeList = resEdu.data.list
      teacherDetail({
        id: cookie.getJSON('user_infor').id
      }).then(res => {
        if (res.code !== 200) {
          // 管理员、老师、学生三者状态的切换待梳理
          cookie.remove(ACCESS_TOKEN)
          cookie.remove(ACCESS_TOKEN, {
            domain: '.' + location.hostname
          })
          cookie.remove('user_type')
          cookie.remove('user_type', {
            domain: '.' + location.hostname
          })
          cookie.remove('user_infor')
          cookie.remove('user_infor', {
            domain: '.' + location.hostname
          })
          window.location.reload()
          return
        }
        for (const key in res.data) {
          if (res.data[key] === '0') res.data[key] = undefined
        }
        const rank = this.rankTypeList.find(item => item.id == res.data.rankId)
        const educatio = this.eduTypeList.find(item => item.id == res.data.educationId)
        this.user = Object.assign(res.data, {
          avatar: cookie.getJSON('user_infor').avatar,
          rankName: rank ? rank.name : '',
          username: cookie.getJSON('user_infor').username,
          educationName: educatio ? educatio.name : ''
        })
        this.user.degreeStr =
          this.qualificationList.find(item => {
            return item.value == this.user.degreeId
          })?.label ?? '暂无'
        this.user.teacherTypeStr = this.teacherTypeList.find(item => item.value == this.user.teacherType).label
      })
    },
    async getStudentDetail() {
      const res = await studentDetail({
        id: cookie.getJSON('user_infor').id
      })
      this.user = Object.assign(res.data, {
        // avatar: cookie.getJSON('user_infor').avatar,
        // rankName: this.rankTypeList.find(item => item.id == res.data.rankId).name,
        // username: cookie.getJSON('user_infor').username,
        // educationName: this.eduTypeList.find(item => item.id == res.data.educationId).name
      })
    },
    async getExternalUserDetail() {
      try {
        await this.professionMapHttp()
        const res = await externalTeacherDetail({ id: cookie.getJSON('user_infor').id })
        this.user = Object.assign(res.data, {
          profession: this.findThirdLevelName(
            this.professionList,
            res.data.collegeId,
            res.data.departmentId,
            res.data.professionId
          )
        })
      } catch (error) {
        console.error('获取外部用户详情时出错:', error)
      }
    },
    change(activeKey) {
      this.activeKey = activeKey
      this[PERSONAL_ACTIVEKEY](activeKey)
    },
    displayData(value, placeholder = '暂无') {
      return value && value !== '0' && value !== 'null' ? value : placeholder
    },
    passwordvalidator(rule, value, callback) {
      const password = this.externalForm.getFieldValue('password')
      if (value && password) {
        if (value !== password) {
          callback(new Error('两次输入的密码不一致！'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    findThirdLevelName(data, firstId, secondId, thirdId) {
      console.log('data, firstId, secondId, thirdId ----->', data, firstId, secondId, thirdId)
      // 遍历第一层数据
      for (let i = 0; i < data.length; i++) {
        const firstLevel = data[i]
        if (firstLevel.id === firstId) {
          // 遍历第二层数据
          for (let j = 0; j < firstLevel.child.length; j++) {
            const secondLevel = firstLevel.child[j]
            if (secondLevel.id === secondId) {
              // 遍历第三层数据
              for (let k = 0; k < secondLevel.child.length; k++) {
                const thirdLevel = secondLevel.child[k]
                if (thirdLevel.id === thirdId) {
                  return thirdLevel.name
                }
              }
            }
          }
        }
      }
      return null
    }
    // if (value && this.form.getFieldValue('confirmPassword')) {
    //   this.$refs.form.validateFields(['confirmPassword'], { force: true })
  },
  mounted() {
    this.role = this.$route.query.role
    const userType = cookie.getJSON('user_type').join(',')
    console.log('userType ----->', userType)
    if (userType.includes('student')) {
      this.isStudent = true
    }
    console.log('this.isStudent ----->', this.isStudent)
    if (userType.includes('external')) {
      this.isCampus = false
    }
    if (this.local_activekey) {
      this.activeKey = this.local_activekey
    }
    this.getUserDetail()
  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 18px 0px 18px 19px;
  .back {
    width: 80px;
    height: 34px;
    display: flex;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-radius: 25px;
    margin-bottom: 25px;
    align-items: center;
    justify-content: center;
    border: 1px solid #d6d6d6;
    img {
      height: 10px;
      margin-right: 9px;
    }
  }
  .title {
    font-size: 16px;
    font-weight: 800;
    color: #000000;
    line-height: 22px;
    position: relative;
    margin-bottom: 22px;
    padding-bottom: 12px;
    &::after {
      left: 0;
      bottom: 0;
      content: '';
      width: 100%;
      height: 1px;
      background: url('~@/assets/img/fg_b.png');
      background-size: 100% 100%;
      background-position: center;
      position: absolute;
    }
  }
  .form {
    padding: 0 15px;
    // position: relative;
    height: calc(100% - 40px);
    overflow-x: auto;
    .list {
      display: flex;
      justify-content: space-between;
      height: 132px;
      overflow: hidden;
      .ant-form-item {
        width: 50%;
        color: #000000;
        padding-left: 18px;
        margin-bottom: 22px;
        .ant-input {
          color: #000;
        }
        .ant-input.ant-input-disabled {
          color: #8a8a8a;
        }
        .ant-form-item-label {
          color: #000000;
          margin-bottom: 6px;
          line-height: normal !important;
        }
        &:last-child {
          margin-bottom: 0;
        }
        &:first-child {
          padding-left: 0;
          padding-right: 18px;
        }
      }
      .avatar-item.ant-form-item {
        padding-left: 11px;
        .avatar-upload {
          width: 70px;
          height: 70px;
          z-index: 999;
          position: relative;
          border-radius: 100%;
          opacity: 0;
          margin-bottom: 20px;
          margin-left: 10px;
        }
        .avatar {
          width: 70px;
          height: 70px;
          top: 0;
          position: absolute;
          border-radius: 100%;
          margin-left: 10px;
        }
      }
      /deep/ .ant-form-item {
        width: 24%;
      }
      /deep/ .ant-select-selection--single {
        height: 36px;
        line-height: 36px !important;
      }
      /deep/.ant-input {
        height: 36px;
        line-height: 36px;
      }
      /deep/ .ant-select-selection__rendered {
        height: 36px;
        line-height: 36px !important;
      }
      /deep/ .ant-form-item-label {
        // margin-bottom: 12px;
      }
      .form-item {
        width: 50%;
        padding-left: 47px;
        margin-bottom: 30px;
        .label {
          font-size: 14px;
          font-weight: 400;
          color: #000000;
          line-height: 20px;
          padding-left: 13px;
          margin-bottom: 12px;
        }
        .input {
          height: 36px;
          padding: 0 11px;
          font-size: 14px;
          font-weight: 400;
          color: #000000;
          line-height: 20px;
          line-height: 36px;
          border-radius: 4px;
          border: 1px solid #d8dce0;
        }
        .avatar {
          width: 70px;
          height: 70px;
          margin-left: 20px;
          border-radius: 100%;
        }
        &:first-child {
          padding-left: 0;
          // padding-right: 47px;
        }
      }
    }
    .form-content {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .form-item {
        width: calc((100% - 240px) / 4);
        margin-bottom: 30px;
        margin-right: 80px;
        .label {
          font-size: 14px;
          font-weight: 550;
          color: #000000;
          line-height: 20px;
          padding-left: 13px;
          margin-bottom: 12px;
        }
        .input {
          height: 36px;
          padding: 0 11px;
          font-size: 14px;
          font-weight: 400;
          color: #000000;
          line-height: 20px;
          line-height: 36px;
          border-radius: 4px;
          border: 1px solid #d8dce0;
        }
        .avatar {
          width: 70px;
          height: 70px;
          margin-left: 20px;
          border-radius: 100%;
        }
        &:first-child {
          padding-left: 0;
          // padding-right: 47px;
        }
      }
      .form-item:nth-child(4n) {
        margin-right: 0px;
      }
      .avatar-item.ant-form-item {
        padding-left: 11px;
        .avatar-upload {
          width: 70px;
          height: 70px;
          z-index: 999;
          position: relative;
          border-radius: 100%;
          opacity: 0;
          margin-bottom: 20px;
        }
        .avatar {
          width: 70px;
          height: 70px;
          top: 0;
          position: absolute;
          border-radius: 100%;
        }
      }
      /deep/ .ant-form-item {
        width: calc((100% - 240px) / 4);
        margin-right: 80px;
      }
      /deep/ .ant-form-item:nth-child(4n) {
        margin-right: 0px;
      }
      /deep/ .ant-select-selection--single {
        height: 36px;
        line-height: 36px !important;
      }
      /deep/.ant-input {
        height: 36px;
        line-height: 36px;
      }
      /deep/ .ant-select-selection__rendered {
        height: 36px;
        line-height: 36px !important;
      }
    }
  }
  .button {
    width: 86%;
    margin-top: 50px;
    margin-bottom: 20px;
    margin-left: 103px;
    text-align: center;
    position: absolute;
    bottom: -30px;
    left: 96px;
    background: #fbfcfd;
    padding-top: 20px;
    padding-bottom: 30px;
    .ant-btn {
      min-width: 87px;
      height: 35px;
    }
  }
  /deep/ .ant-tabs {
    height: calc(100% - 126px);
    .ant-tabs-content {
      height: calc(100% - 40px);
      overflow-y: auto;
    }
    .ant-tabs-tabpane {
      // height: 100%;
    }
  }
  /deep/ .ant-tabs-left-bar {
    // height: calc(100% - 175px);
    border: none;
    background: linear-gradient(to bottom, #f5f5f6, #ffffff);
    margin-right: 15px;
    padding-top: 22px;
  }
  /deep/ .ant-tabs-ink-bar {
    height: 0 !important;
  }
  /deep/ .ant-tabs-left-content {
    border: none;
    background: #fbfcfd;
    padding-top: 24px;
    padding-right: 22px;
  }
  /deep/ .ant-tabs-tab-active {
    position: relative;
    &::after {
      content: '';
      position: absolute;
      left: 12px;
      top: 14px;
      bottom: 0;
      width: 2px; /* 设置竖线宽度 */
      height: 10px;
      background-color: #ffa000; /* 设置竖线颜色 */
    }
  }
  /deep/ .ant-tabs .ant-tabs-left-bar .ant-tabs-tab {
    font-weight: bold;
    text-align: left;
    // #FF6D00
  }
  /deep/ .ant-tabs-nav .ant-tabs-tab-active {
    color: #ff6d00 !important;
  }
}
</style>
<style lang="less">
.personal-modal {
  .ant-form-item-children {
    display: block;
  }
}
</style>
